import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import { setEdgeServers } from '../../../../shared/lib/setEdgeServers'
import {
  useDeletePlanMenuTypeToFotoboxesMutation,
  useSendPlanMenuTypeToFotoboxesMutation,
} from '../../../../core/api/PlanMenuTypeApi'

export const useUpdatePlanMenuTypeStations = (
  oldValue: IEdgeServers[],
  newValue: IEdgeServers[],
) => {
  const { deletedItems, addedItems } = setEdgeServers(oldValue, newValue) || {}

  const [sendPlanMenuTypeToFotoboxes] = useSendPlanMenuTypeToFotoboxesMutation()
  const [deletePlanMenuTypeToFotoboxes] =
    useDeletePlanMenuTypeToFotoboxesMutation()

  const onUpdateStation = (planMenuTypeGuids: string) => {
    if (
      deletedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      deletePlanMenuTypeToFotoboxes({
        planMenuTypesGuids: [planMenuTypeGuids],
        edgeServersGuids: deletedItems,
      })
    }
    if (
      addedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      sendPlanMenuTypeToFotoboxes({
        planMenuTypesGuids: [planMenuTypeGuids],
        edgeServersGuids: addedItems,
      })
    }
  }
  return { onUpdateStation }
}
